import React from 'react';
import { Flex, Stack, SvgCaretRight } from '@grubhubprod/gh-cookbook-react';
import { CustomLink } from 'src/components/Breadcrumbs/CustomLink';

export interface IBreadcrumbItem {
  label: string;
  href: string;
  useRouterLink?: boolean;
}

interface IBreadcrumbsProps {
  breadcrumbs: IBreadcrumbItem[];
}

export function Breadcrumbs({
  breadcrumbs = [],
}: IBreadcrumbsProps): JSX.Element {
  if (breadcrumbs.length > 0) {
    return (
      <Flex as="ul" className="removeListStyles" alignItems="center">
        {breadcrumbs.map((breadcrumbsProps, index) => {
          const { href } = breadcrumbsProps;
          const isLastBreadcrumb = index === breadcrumbs.length - 1;

          return (
            <Flex as="li" key={href} alignItems="center">
              <Stack x={isLastBreadcrumb ? 'none' : 'xxx-sm'}>
                <CustomLink {...breadcrumbsProps} />
              </Stack>
              {!isLastBreadcrumb && (
                <Stack x="xxx-sm">
                  <SvgCaretRight />
                </Stack>
              )}
            </Flex>
          );
        })}
      </Flex>
    );
  }

  return null;
}
